import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 rounded-lg overflow-hidden">
                <img 
                  src="/images/bee-icon.png" 
                  alt="UrbanHive - Apiculture Urbaine" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-xl font-serif font-bold text-white">UrbanHive</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-md">
              Votre guide complet pour l'apiculture urbaine et les ruches de balcon. 
              Apprenez à héberger des abeilles en ville, à respecter la réglementation, 
              et à récolter votre premier miel urbain.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-honey transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-honey transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-honey transition-colors">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/getting-started" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Débuter
                </Link>
              </li>
              <li>
                <Link to="/equipment" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Équipement
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Réglementation
                </Link>
              </li>
              <li>
                <Link to="/lexique" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Lexique
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Politique de Confidentialité
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Conditions d'Utilisation
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-honey transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-500">
            © 2025 UrbanHive. Tous droits réservés. Apiculture urbaine responsable.
          </p>
        </div>
      </div>
    </footer>
  );
};
